<!-- Modal -->
<div class="modal" tabindex="-1" id="dolgPermission" role="dialog" aria-labelledby="dolgPermission" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">

    <div [ngClass]="{'hidden': !saveInProgress}" class="dolgPermissionquitConfirmation">
      <div class="quitConfirmationContent">
        Mentés folyamatban...
      </div>
    </div>

    <div [ngClass]="{'hidden': !loading}" class="dolgPermissionquitConfirmation">
      <div class="quitConfirmationContent">
        Adatok betöltése folyamatban...
      </div>
    </div>

    <div id="saveSuccess" [ngClass]="{'showResult': saveResult == 0}">
      {{ successMessage }}
    </div>
Fszűrés
    <div id="saveError" [ngClass]="{'showResult': saveResult == -1}">
      <div class="closeResult" (click)="closeResult()">x</div>
      <div class="saveErrorContent">
        <span>{{ saveErrorDescription }}</span>
      </div>
    </div>

    <div class="modal-content">
      <div class="modal-header">

        <h5 class="modal-title">Dolgozói áthaladási szabályok</h5>
        <button class="btn btn-secondary" data-dismiss="modal" (click)="resetModal()">X</button>
      </div>
      <div class="modal-body">
        <div class="container-fluid min-height">

          <div *ngIf="!loading">

            <form class="form-group" [formGroup]="requestDetails">
              <div class="col-md-12">

                <div class="row">
                  <div class="col-12">
                    <div class="row mb-3">
                        <ng-select [searchable]="true" formControlName="patientName" placeholder="Dolgozó választás"
                          [items]="patientList" bindLabel="displayData" bindValue="tapass"
                          (change)="onSelectedPatientChange($event)" [loading]="patientListLoading"
                          loadingText="Betöltés..." notFoundText="Nincs találat" class="mr-2 w100-90">
                        </ng-select>
                    </div>

                    <div class="row  mb-3">
                      <div class="col-md-3">
                        <div class="row">
                        <ng-select class="w100" [searchable]="true" placeholder="Beléptető eszköz"
                          formControlName="acDeviceFilter" [items]="acDeviceList" bindLabel="deviceName"
                          bindValue="deviceId" [clearable]="false" loadingText="Betöltés..."
                          [multiple]="true"
                          notFoundText="Nincs találat" >
                        </ng-select>
                      </div>
                      </div>

                      <div class="col-md-3">
                        <div class="row">
                          <div class="col-md-3">Tól:</div>
                          <div class="col-md-9">
                            <!-- <input type="date" class="form-control" [formControl]="dateFromInput"
                          (change)="setStartDate()"> -->

                            <div class="input-group mr-1">
                              <input class="form-control mb-2" placeholder="yyyy-mm-dd" name="dp"
                                formControlName="dateFromInput" ngbDatepicker #dFrom="ngbDatepicker" [minDate]="{year: 1900, month: 1, day: 1}"
                                [ngClass]="{'date-invalid': dateInvalidStart === true}">
                              <div class="input-group-append">
                                <button class="btn btn-outline-secondary calendar" (click)="dFrom.toggle()"
                                  type="button"></button>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="row">
                          <div class="col-md-3">Ig:</div>
                          <div class="col-md-9">
                            <!-- <input type="date" class="form-control" [formControl]="dateToInput"
                          (change)="setEndDate()"> -->

                            <div class="input-group mr-1">
                              <input class="form-control mb-2" placeholder="yyyy-mm-dd" name="dp"
                                formControlName="dateToInput" ngbDatepicker #dTo="ngbDatepicker" [minDate]="{year: 1900, month: 1, day: 1}"
                                [ngClass]="{'date-invalid': dateInvalidEnd === true}">
                              <div class="input-group-append">
                                <button class="btn btn-outline-secondary calendar" (click)="dTo.toggle()"
                                  type="button"></button>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                      <div class="col-md-3">
                        <button class="btn btn-primary" (click)="onManageCheckPermission()"
                          [disabled]="dateInvalidEnd || dateInvalidStart || requestDetails.invalid">
                          Mentés
                        </button>
                      </div>
                    </div>





                  </div>
                </div>
              </div>
            </form>

            <div class="col-md-12 text-center" *ngIf="eventLogRows.length == 0 && pristine == false">
              <h5>
                A megadott időintervallumban nincs esemény.
              </h5>
            </div>
            <!-- <mat-form-field>
              <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Szűrés" #filterTable
                [formControl]="filterInput">
              <i mat-button matSuffix mat-icon-button class="fa fa-times"
                (click)="filterInput.reset(); applyFilter('')"></i>
            </mat-form-field> -->

            <mat-table [dataSource]="dataSource" matSort id="print-section">
              <ng-container matColumnDef="permname">
                <mat-header-cell *matHeaderCellDef> Jogosultság </mat-header-cell>
                <mat-cell *matCellDef="let element"><span class="ellipsis"> {{element.deviceName}}</span> </mat-cell>
              </ng-container>
              <ng-container matColumnDef="permstatus">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Jog státusza </mat-header-cell>
                <mat-cell *matCellDef="let element"><span class="ellipsis"> {{element.grantStatus}} </span></mat-cell>
              </ng-container>
              <ng-container matColumnDef="datefrom">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Érvényesség (tól) </mat-header-cell>
                <mat-cell *matCellDef="let element"><span class="ellipsis"> {{element.grantFrom | date:'yyyy-MM-dd'}}
                  </span></mat-cell>
              </ng-container>
              <ng-container matColumnDef="dateto">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Érvényesség (ig) </mat-header-cell>
                <mat-cell *matCellDef="let element"><span class="ellipsis"> {{element.grantTo | date:'yyyy-MM-dd'}}
                  </span></mat-cell>
              </ng-container>
              <ng-container matColumnDef="archive">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Inaktíválás</mat-header-cell>
                <mat-cell *matCellDef="let element"><span class="ellipsis"> <i *ngIf = "element.grantStatus == 'ACTIVE'" class="fa fa-minus-circle" (click)="archivePermission(element)"></i>
                  </span></mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>
            <!-- <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator> -->


          </div>



        </div>
      </div>
    </div>
  </div>
</div>
